import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { Checkbox, Input, InputNumber } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import TextArea from 'antd/es/input/TextArea';
import { useNavigate } from 'react-router-dom';
import { createTag, findTagById, updateTag } from '../../../../service/tagService';
import { TagRequest } from '../../../../model/request';
import toast, { NotifyType } from '../../../../utils/toast';

function TagForm() {
  const { id } = useParams();
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [webViewActive, setWebViewActive] = useState(true);
  const [webViewOrder, setWebViewOrder] = useState<number>(1);
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      findTagById(id)
        .then((tag) => {
          setName(tag.name);
          setDescription(tag.description || '');
          setWebViewActive(tag.webViewActive);
          setWebViewOrder(tag.webViewOrder);
        })
        .catch((e) => console.error(e));
    }
  }, [id]);

  function handleGoBack() {
    navigate('/learning-assets/tags');
  }

  async function handleSubmit() {
    try {
      const tagRequest: TagRequest = {
        name,
        description,
        webViewActive: webViewActive,
        webViewOrder: webViewOrder,
      };
      id ? await updateTag(id, tagRequest) : await createTag(tagRequest);
      toast(NotifyType.INFO, id ? 'Cập nhật thẻ thành công' : 'Tạo thẻ thành công');
      navigate('/learning-assets/tags');
    } catch (err) {
      console.error(err);
      toast(NotifyType.ERROR, id ? 'Cập nhật thẻ không thành công' : 'Tạo thẻ không thành công');
    }
  }

  return (
    <div className={'w-full h-full bg-white flex flex-col'}>
      <div className="w-full border-b-1 border-[silver] h-[60px] flex items-center justify-between px-4">
        <button className="px-3 cursor-pointer rounded w-fit h-fit " onClick={handleGoBack}>
          <ArrowLeftOutlined className="text-[20px]" />
        </button>
        <button
          className="px-3 py-2 bg-[#e6f8ff] rounded w-fit h-fit text-[18px] hover:bg-[#d8f0fa]"
          onClick={handleSubmit}
        >
          Lưu
        </button>
      </div>
      <div className={'w-full p-8 h-[calc(100vh-160px)] overflow-y-auto'}>
        <h2 className={'font-bold text-xl'}>{id ? 'Chỉnh sửa thẻ' : 'Thêm thẻ mới'}</h2>
        <div className="flex items-center mt-2">
          <div className="text-[18px] w-[20%] text-left">Tên thẻ:</div>
          <Input className="flex-1" name={'name'} value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        <div className="flex items-center mt-2">
          <div className="text-[18px] w-[20%] text-left">Mô tả chi tiết:</div>
          <TextArea
            className="flex-1"
            name={'description'}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={6}
          />
        </div>
        <div className="flex items-center gap-2 mt-2">
          <label>Hiển thị trên web</label> <br />
          <Checkbox checked={webViewActive} onChange={(e) => setWebViewActive(e.target.checked)} />
        </div>
        <div className="flex items-center gap-2 mt-2">
          <label>
            Độ ưu tiên hiển thị <span className={'text-FF1D30'}>*</span>
          </label>{' '}
          <br />
          <InputNumber
            placeholder="Nhập độ ưu tiên hiển thị..."
            value={webViewOrder}
            onChange={(e) => setWebViewOrder(e || 1)}
            required
          />
        </div>
      </div>
    </div>
  );
}

export default TagForm;
